<div
  *transloco="let t; read: 'configurations.analytic-item-info'"
  class="xi-modal__container analytic-type-info-dialog__container"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>
  <div class="xi-modal__content">
    <p>
      <span class="analytic-type-info__item">{{ t('entities-header') }}</span
      >: {{ t('entities-content') }}
      <a target="_blank" href="https://semantria-docs.lexalytics.com/docs/entity-configuration">{{
        t('more')
      }}</a>
    </p>

    <p>
      <span class="analytic-type-info__item">{{ t('sentiment-header') }}</span
      >: {{ t('sentiment-content') }}
      <a
        target="_blank"
        href="https://semantria-docs.lexalytics.com/docs/sentiment-bearing-phrases"
        >{{ t('more') }}</a
      >
    </p>

    <p>
      <span class="analytic-type-info__item">{{ t('queries-header') }}</span
      >: {{ t('queries-content') }}
      <a target="_blank" href="https://semantria-docs.lexalytics.com/docs/queries-query-topics">{{
        t('more')
      }}</a>
    </p>

    <p>
      <span class="analytic-type-info__item">{{ t('topics-header') }}</span
      >: {{ t('topics-content') }}
      <a
        target="_blank"
        href="https://semantria-docs.lexalytics.com/docs/user-categories-concept-topics"
        >{{ t('more') }}</a
      >
    </p>

    <p>
      <span class="analytic-type-info__item">{{ t('taxonomy-header') }}</span
      >: {{ t('taxonomy-content') }}
      <a target="_blank" href="https://semantria-docs.lexalytics.com/docs/taxonomy">{{
        t('more')
      }}</a>
    </p>

    <p>
      <span class="analytic-type-info__item">{{ t('blacklist-header') }}</span
      >: {{ t('blacklist-content') }}
      <a target="_blank" href="https://semantria-docs.lexalytics.com/docs/blacklist">{{
        t('more')
      }}</a>
    </p>
  </div>
</div>
